import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UtilStorageService } from "src/app/admihair/service/util-storage.service";
import { ConfirmationService, Message, SelectItem } from "primeng/api";
import { ErroService } from "src/app/admihair/service/erro.service";
import { ItemServicoService } from "src/app/admihair/service/item-servico.service";
import { ItemServico } from "src/app/admihair/api/dto/item-servico";
import { Paginador } from "src/app/admihair/api/dto/paginacao/paginador";
import { AdmihairBaseComponent } from "../../../admihair-base.component";

@Component({
  selector: "app-item-servico-listar",
  templateUrl: "./item-servico-listar.component.html",
  styleUrls: ["./item-servico-listar.component.scss"],
})
export class ItemServicoListarComponent extends AdmihairBaseComponent implements OnInit {

  situacoesStatus: SelectItem[] = [
    { label: "ATIVOS", value: true },
    { label: "INATIVOS", value: false },
  ];
  situcaoSelecionada: boolean = true;
  loadingTable: boolean = false;
  loadingServicos: boolean = false;
  itensServicos: ItemServico[] = [];
  itensServicosPaginados?: Paginador<ItemServico>;
  numeroPagina = 0;
  inputBusca?: string = "";
  @ViewChild("filter") filter!: ElementRef;

  loadingRelatorioPrecificacao: boolean = false;
  loadingRelatorioPreco: boolean = false;

  constructor(
    erroService: ErroService,
    utilStorageService: UtilStorageService,
    router: Router,
    activatedRoute: ActivatedRoute,
    private itemServicoService: ItemServicoService,
    private confirmationService: ConfirmationService
  ) {
    super(erroService, utilStorageService, router, activatedRoute);
  }

  ngOnInit(): void {
    this.setExibirSpinnerPrincipal(true);
    this.verificarPermissoes();
    if (this.permissaoListar) {
      this.carregarItensServicos(this.numeroPagina);
    }
  }

  carregarItensServicos(pagina: number) {
    this.loadingTable = true;
    this.itemServicoService
      .listarTodosPorEmpresaESituacaoETextoBuscaPaginado(
        this.getEmpresa().id,
        this.situcaoSelecionada,
        pagina,
        this.inputBusca
      )
      .subscribe({
        next: (data: Paginador<ItemServico>) => {
          this.loadingTable = false;
          this.setExibirSpinnerPrincipal(false);
          this.itensServicosPaginados = data;
          this.itensServicos = data.content;
        },
        error: (err: any) => {
          this.loadingTable = false;
          this.setExibirSpinnerPrincipal(false);
          this.exibirMensagemErro(err);
        },
      });
  }

  onPageChange(event: any) {
    if (this.itensServicosPaginados) {
      this.numeroPagina = (event.first + event.rows) / this.itensServicosPaginados.size;
    }
    this.carregarItensServicos(this.numeroPagina - 1);
  }

  excluirItemServico(id: number) {
    this.confirmationService.confirm({
      message: "Tem certeza que seja excluir?",
      header: "Confirmação",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      icon: "pi pi-info-circle",
      accept: () => {
        this.itemServicoService.excluir(id).subscribe({
          next: () => {
            this.carregarItensServicos(0);
            this.exibirMensagemSucesso();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          },
        });
      },
    });
  }

  buscar(event: Event) {
    this.loadingTable = true;
    this.inputBusca = (event.target as HTMLInputElement).value;
    this.carregarItensServicos(0);
  }

  limpar() {
    this.loadingTable = true;
    this.filter.nativeElement.value = "";
    this.inputBusca = "";
    this.carregarItensServicos(0);
  }

  verificarPermissoes() {
    this.permissaoListar = this.verificarPermissao("PERM_LISTAR_SERVICO");
    this.permissaoInserir = this.verificarPermissao("PERM_INSERIR_SERVICO");
    this.permissaoDetalhar = this.verificarPermissao("PERM_DETALHAR_SERVICO");
    this.permissaoEditar = this.verificarPermissao("PERM_EDITAR_SERVICO");
    this.permissaoExcluir = this.verificarPermissao("PERM_EXCLUIR_SERVICO");
  }

  obterRelatorioPrecificacao() {
    this.loadingRelatorioPrecificacao = true;
    this.itemServicoService.obterRelatorioPrecificacao(this.getEmpresa().id).subscribe({
      next: (data: any) => {
        this.loadingRelatorioPrecificacao = false;
        
        const blob = new Blob([data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
        window.URL.revokeObjectURL(url);
      },
      error: (err: any) => {
        this.loadingRelatorioPrecificacao = false;
        const reader = new FileReader();
        reader.onload = () => {
          const jsonError = JSON.parse(reader.result as string);
          console.log(jsonError)
          err.error = jsonError;
          this.exibirMensagemErro(err);
        };
        reader.readAsText(err.error);

      }
    })
  }

  obterRelatorioPreco() {
    this.loadingRelatorioPreco = true;
    this.itemServicoService.obterRelatorioPrecoAgrupado(this.getEmpresa().id).subscribe({
      next: (data: any) => {
        this.loadingRelatorioPreco = false;
        
        const blob = new Blob([data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
        window.URL.revokeObjectURL(url);
      },
      error: (err: any) => {
        this.loadingRelatorioPreco = false;
        const reader = new FileReader();
        reader.onload = () => {
          const jsonError = JSON.parse(reader.result as string);
          console.log(jsonError)
          err.error = jsonError;
          this.exibirMensagemErro(err);
        };
        reader.readAsText(err.error);

      }
    })
  }
}
